// CSS
import './ResultIndexOverlay.css';
// React hooks
import ReactDOM from 'react-dom';   // for React Portals



// ==================
// ResultIndexOverlay – the '/results' Product page component that is embedded into the ToastCue (popover)
// ==================
function ResultIndexOverlay({
    text,   // the display text
}){
    
    // JSX Component – React Portal
    return ReactDOM.createPortal(
        <>
            <div className='ResultIndexOverlay'>{text}</div>
        </>
    , document.getElementById("modal-root"));
};


// Export statement
export default ResultIndexOverlay;